import type { Asset } from '@kontentowo/shared';

/** Only selectable stored video assets belonging to the BloodCrimes brand. */
export function listBloodCrimesProgramVideoAssets(assets: readonly Asset[], brandId: string | null): Asset[] {
  if (!brandId) return [];
  return assets.filter((asset) => asset.brandId === brandId && asset.type === 'VIDEO' && asset.mimeType.startsWith('video/'));
}
